import { TokenResponse } from '@/types/openid';
import { Session } from '@/types/session';

export const tokenProcessing = (tokenResponse: TokenResponse): Session => {
  const calcTokenExpiresAt = (expiresIn: number, createdAt: number): string => {
    // トークンの有効な秒数[sec] + トークン作成日時(UNIX時間)[sec]
    // Dateがmsec換算のため×1000を追加
    return new Date((expiresIn + createdAt) * 1000).toISOString();
  };

  return {
    token: tokenResponse.accessToken,
    refreshToken: tokenResponse.refreshToken,
    createdAt: new Date(tokenResponse.createdAt * 1000).toISOString(),
    expiredAt: calcTokenExpiresAt(
      tokenResponse.expiresIn,
      tokenResponse.createdAt,
    ),
    refreshTokenExpiresAt: calcTokenExpiresAt(
      tokenResponse.refreshTokenExpiresIn,
      tokenResponse.createdAt,
    ),
    affiliations: [],
  };
};
